var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFacebookW(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.602,
    height: 15.049,
    viewBox: "0 0 7.602 15.049",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "facebook_2_",
    "data-name": "facebook (2)",
    d: "M126.925,8.015h1.65v6.791a.243.243,0,0,0,.243.243h2.8a.243.243,0,0,0,.243-.243V8.047h1.9a.243.243,0,0,0,.241-.215l.288-2.5a.243.243,0,0,0-.241-.271h-2.184V3.494c0-.472.254-.712.756-.712h1.428a.243.243,0,0,0,.243-.243V.245A.243.243,0,0,0,134.041,0h-1.968l-.09,0a3.772,3.772,0,0,0-2.466.93,2.586,2.586,0,0,0-.86,2.3V5.062h-1.732a.243.243,0,0,0-.243.243V7.773A.243.243,0,0,0,126.925,8.015Z",
    transform: "translate(-126.682)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFacebookW);
export default __webpack_public_path__ + "static/media/icon-facebook-w.d64715a22828fa0113a80f3b6e421998.svg";
export { ForwardRef as ReactComponent };